<!-- ///////////////////////////////////////////////////////////////////////////////////////// -->
<!-- // view -->
<!-- ///////////////////////////////////////////////////////////////////////////////////////// -->
<template>
  <div class="container">
    <!-- <h2>あなたの大切なCNPPをパラダイスロック！</h2>
    <div class="form-label text-body">※ロックや解除にはガス代が発生します</div><br/>
    <div class="form-label text-body">※ロックするとシードフレーズや秘密鍵が盗まれないかぎり、勝手に転送されることはありません</div><br/>
    <div class="form-label text-body">※OpenSeaなどで売却する時には必ず解除しましょう</div><br/> -->
    <br/>

     <!-- 1. メタマスクが使えないブラウザ -->
     <template v-if="!canUseMetaMask()">
        <div>ブラウザでメタマスクが使える状態になっていません</div>
      </template>
      <!-- 2. メタマスク未接続 -->
      <template v-else-if="!connectedMetaMask()">
      <!-- <template v-if="!connectedMetaMask()"> -->
        <dev class="form-label text-body">メタマスク（メインネット）で接続してください</dev><br/><br/>
        <button class="btn btn-primary my-md-4 w-180px" @click="onClickConnect">ウォレット接続する</button><br/>
        <dev v-show="networkchange" class="form-label text-danger font-weight-bold">メインネットに切り替えてください</dev>

        <br/>
        <dev>
          <!-- <img class="locklogo" alt="PandaLock_key" src="../assets/PandaLock_key1.png"> -->
        </dev>
      </template>
      <template v-else-if="array_tokenid.length == 0">
        <div v-show="loading" class="loader">Now loading...</div>
        <dev class="form-label text-body" v-show="!loading">CNPPをお持ちでありません。。OpenSeaで購入してみよう！</dev><br/><br/>
        <a href="https://opensea.io/ja/collection/cnp-philippines-happydaoyarou" target="_blank" v-show="!loading">OpenSeaを見てみる。</a>
      </template>
      <!-- 3. その他(メタマスク接続済) -->
      <template v-else>
        <div v-show="loading" class="loader">Now loading...</div>
        <!-- メニュー切り替え -->
        <div class="btn-group btn-group-toggle" data-toggle="buttons"  v-show="!loading">
          <!-- <label class="btn btn-outline-secondary" v-bind:class="{'btn-warning font-weight-bold': toggled === 1, 'btn-outline-secondary': toggled !== 1}">
            <input type="radio" name="options" id="normal" v-model="moderadio" value="normal" @change="onModeCahange()"> 個別管理
          </label> -->
          <label class="btn btn-outline-secondary" v-bind:class="{'btn-warning font-weight-bold': toggled === 2, 'btn-outline-secondary': toggled !== 2}">
            <input type="radio" name="options" id="batchlock" v-model="moderadio" value="batchlock" @change="onModeCahange_2()"> Lock
          </label>
          <label class="btn btn-outline-secondary" v-bind:class="{'btn-warning font-weight-bold': toggled === 3, 'btn-outline-secondary': toggled !== 3}">
            <input type="radio" name="options" id="batchrelease" v-model="moderadio" value="batchrelease" @change="onModeCahange_3()"> Unlock
          </label>
          <!-- <label class="btn btn-outline-secondary" v-bind:class="{'btn-warning font-weight-bold': toggled === 4, 'btn-outline-secondary': toggled !== 4}">
            <input type="radio" name="options" id="info" v-model="moderadio" value="info" @change="onModeCahange_4()"> ロック情報
          </label> -->
        </div>
        <br/><br/>

        <!-- ロック/解除メイン機能 -->
        <div class="collection-detail"  v-show="!loading">
          <template v-if="moderadio == 'normal'">
            <!-- 個別管理 -->
            <div  v-for="(tokenid,index_token) in array_tokenid" :key="tokenid.Object">
                <!-- <a v-bind:href="'https://opensea.io/assets/ethereum/' + array_tokenid[index_token].contract +'/' + array_tokenid[index_colle][index_token].id" target="_blank" > -->
                <img :src="array_tokenid[index_token].image" height="120" class="shadow p-1 mb-3 bg-white rounded imagebox"  :id="`image${index_token}`">
                <!-- </a> -->
                <div class="box h6">{{array_tokenid[index_token].title}}</div>
                
                <br/>
                <!-- チェックボックス -->
                <input type="checkbox" v-model="lockednft[index_token]" :id="'cb' + index_token" @change="onCheckCahange()"/>
                <br/>
                <label class = "h6 m-1" :for="'cb' + index_token">{{lockedchange_string[index_token]}}</label>

                <br/>
                <!-- ロック設定ボタン -->
                <div v-if="lockedchange[index_token] == true">
                  <button class="btn btn-primary my-md-4" @click="onClickSetting(index_token)">execute🌈</button><br/>
                </div>
                <div v-else>
                  <button class="btn btn-secondary my-md-4" disabled >execute🌈</button><br/><br/>
                </div>
            </div>           
          </template>
          <template v-else-if="moderadio == 'batchlock'">
            <!-- 一括ロック -->
            <div  v-for="(tokenid,index_token) in array_tokenid" :key="tokenid.Object">
              <div v-if="const_lockednft[index_token] == false">
                <!-- <a v-bind:href="'https://opensea.io/assets/ethereum/' + array_tokenid[index_token].contract +'/' + array_tokenid[index_colle][index_token].id" target="_blank" > -->
                <img :src="array_tokenid[index_token].image" height="120" class="shadow p-1 mb-3 bg-white rounded imagebox"  :id="`image${index_token}`">
                <!-- </a> -->
                <div class="box h6">{{array_tokenid[index_token].title}}</div>
                
                <!-- <br/> -->
                <!-- チェックボックス -->
                <input type="checkbox" v-model="lockednft_2[index_token]" :id="'cb' + index_token" @change="onCheckCahange_2()"/>
                <br/>
                <label class = "h5 m-2" :for="'cb' + index_token">{{lockedchange_string_2[index_token]}}</label>

                <br/>
              </div>
            </div>
          </template>
          <template v-else-if="moderadio == 'batchrelease'">
            <!-- 一括解除 -->
            <div  v-for="(tokenid,index_token) in array_tokenid" :key="tokenid.Object">
              <div v-if="const_lockednft[index_token] == true">
                <!-- <a v-bind:href="'https://opensea.io/assets/ethereum/' + array_tokenid[index_token].contract +'/' + array_tokenid[index_colle][index_token].id" target="_blank" > -->
                <img :src="array_tokenid[index_token].image" height="120" class="shadow p-1 mb-3 bg-white rounded imagebox"  :id="`image${index_token}`">
                <!-- </a> -->
                <div class="box h6">{{array_tokenid[index_token].title}}</div>
                
                <br/>
                <!-- チェックボックス -->
                <input type="checkbox" v-model="lockednft_3[index_token]" :id="'cb' + index_token" @change="onCheckCahange_3()"/>
                <br/>
                <label class = "h5 m-2" :for="'cb' + index_token">{{lockedchange_string_3[index_token]}}</label>

                <br/>
              </div>
            </div>
          </template>
          <!-- パラダイスロック率表記 -->
          <template v-else>
          <!-- <template v-if="connectedMetaMask() && !loading"> -->
            <div class="container">
              <H3>パラダイスロック率の推移📈</H3><br/><br/>
              <H4 style="font-weight:bold; color:#FF0000;/*赤色*/">本日：{{nftLock[0]}} %</H4><br/>
              <!-- <H5>昨日：{{Math.round((Number(nftLock[1]) / 7440) * 100 *100) /100 }} %</H5><br/>
              <H5>一昨日：{{Math.round((Number(nftLock[2]) / 7440) * 100 *100) /100 }} %</H5><br/>
              <H5>先週：{{Math.round((Number(nftLock[6]) / 7440) * 100 *100) /100 }} %</H5><br/> -->
              <line-chart :chart-data="datacollection"></line-chart>
              <div>※運営保有分を抜いた率となります</div><br/>
              <div>※日本時間0:00頃に集計しています</div><br/>
              <hr size = "2" width="100%">
            </div>
            <div class="container">
              <H3>あなたの現在の「パラダイスポイント」</H3><br/><br/>
              <!-- <H4>Comming soon...</H4> -->
              <H4 style="font-weight:bold; color:#FF0000;/*赤色*/">現在 {{pandaPoint}} ポイント</H4><br/>
            </div>
          </template>    
        </div> 

        <!-- 一括ボタンの表示 -->
        <template v-if="moderadio == 'normal' || moderadio == 'info'">
            <!-- 何も表示しない -->
          </template>
          <template v-else-if="moderadio == 'batchlock' && loading == false">
            <br/> 
            <!-- 一括ロック設定ボタン -->
            <div v-if="(lockstate == 1)">
              <H3>All your CNPP are already locked!</H3>
            </div>
            <div v-else-if="enableGo_2 == true">
                  <button class="btn btn-primary my-md-4" @click="onClickSetting_2()">lock execute!🌈</button><br/>
            </div>
            <div v-else>
              <button class="btn btn-secondary my-md-4" disabled >lock execute!🌈</button><br/><br/>
            </div>
          </template>
          <template v-else-if="moderadio == 'batchrelease' && loading == false">
            <!-- 一括解除設定ボタン -->
            <div v-if="(lockstate == 2)">
              <H3>All your CNPP are unlocked.</H3>
            </div>
            <div v-else-if="enableGo_3 == true">
                  <button class="btn btn-primary my-md-4" @click="onClickSetting_3()">unlock execute!🌈</button><br/>
            </div>
            <div v-else>
              <button class="btn btn-secondary my-md-4" disabled >unlock execute!🌈</button><br/><br/>
            </div>
          </template>
        <br/><br/>
      </template>

      <br/><br/>
      
      



  </div>
</template>

<!-- ///////////////////////////////////////////////////////////////////////////////////////// -->
<!-- // script -->
<!-- ///////////////////////////////////////////////////////////////////////////////////////// -->
<script>
import { ethers } from "ethers";
import axios from 'axios'
import LineChart from './LineChart.js'
import {
  Network,
  Alchemy
} from "alchemy-sdk";

// const SIG_API_URL = "https://app-webapi.azurewebsites.net/OffchainSig/";
const SIG_API_URL = "https://express.japaneast.cloudapp.azure.com/OffchainSig/";

// get連続用のタイマー（opensea 429対策）
const sleep = waitTime => new Promise( resolve => setTimeout(resolve, waitTime) );

const settings = {
  apiKey: process.env.VUE_APP_ALCHEMY_API_KEY, // Replace with your Alchemy API Key.
  network: Network.ETH_MAINNET, // Replace with your network.  //!
  // network: Network.ETH_GOERLI,
  maxRetries: 10,
};

export default {
  components: {
      LineChart
  },
  data(){
      return{
        connect:null,
        ethereum:null,
        loading:false,
        //! CNPPのコントラクトアドレス
        nft_contractAddress: "0xCdd9fe65d725675344F6b428D514d3f81D1e6c7d", 
        //! StakeMagnageのコントラクトアドレス※切り替え時に変更する！ 
        stake_contractAddress:"0xa54a6e3AA685027b7FAefB6421AB10f0939cee27",
        networkchange:false,

        toggled:2,

        array_tokenid:[],
        havenft:[],
        lockstate:0,  // 0:lock and unlock,1:all lock,2:all unlock

        const_lockednft:[],
        lockednft:[],
        lockedchange:[],
        lockedchange_string:[],

        lockednft_2:[],
        lockedchange_2:[],
        lockedchange_string_2:[],
        enableGo_2:false,

        lockednft_3:[],
        lockedchange_3:[],
        lockedchange_string_3:[],
        enableGo_3:false,

        moderadio:'batchlock',

        // NFTロック
        nftLock:[],
        datacollection: null,
        pandaPoint:0,
      }
  },
  mounted () {
      // metamaskオンリーの場合はmountedで拾うようにする
      this.ethereum = window.ethereum
      console.log("this.ethereum:",this.ethereum)
  },
  methods: {
    async onClickConnect () {
      
      // ウォレット接続
      this.ethereum = window.ethereum
      console.log("this.ethereum:",this.ethereum)

      // walletアドレス取得（Ledgerは1となることを確認済み）
      if(this.ethereum.chainId == '0x1' || this.ethereum.chainId == '1'){  //!
      // if(this.ethereum.chainId == '0x5'){
        console.log("connected");
        this.networkchange = false;
        // metamask
        const accounts = await this.ethereum.request({ method: 'eth_requestAccounts' })
        const account = accounts[0]
        this.connect = account
       
        console.log("walletaddress:",this.connect)

        this.loading = true;

        //保有しているNFTとロック情報を取得------
        try{
          // --ここからethers
          const provider = new ethers.providers.Web3Provider(this.ethereum) // 選択されたネットワークで繋ぐ
          // const bn = await provider.getBlockNumber()
          const abi = require("../contracts/abi.json");  // JSONはそのまま読み込んで使う（.abiとか不要！）
          const readOnlyContract = new ethers.Contract(this.nft_contractAddress, abi,provider); // 読み込みだけならこれつかえばOK
          // tokensOfOwner実行
          this.havenft = await readOnlyContract.tokensOfOwner(this.connect);
          console.log('this.havenft',this.havenft);

          // getLockState実行
          this.const_lockednft = await readOnlyContract.getStakeStateOfOwner(this.connect);
          this.lockednft = JSON.parse(JSON.stringify(this.const_lockednft)); 
          console.log('this.lockednft',this.lockednft);

          var bLock = false;
          var bUnlock = false;
          for(let i =0; i < this.const_lockednft.length;i++){
            this.lockedchange_2[i] = false;
            this.lockedchange_3[i] = false;
            if(this.lockednft[i] == true){
              this.lockedchange_string_2[i] = "lock";
              this.lockedchange_string_3[i] = "lock";
              bLock = true;
            }else{
              this.lockedchange_string_2[i] = "unlock";
              this.lockedchange_string_3[i] = "unlock";
              bUnlock = true;
            }
          }

          if(bLock == true && bUnlock == false){
            this.lockstate = 1; //all lock
          }else if(bLock == false && bUnlock == true){
            this.lockstate = 2; //all unlock
          }else{
            this.lockstate = 3;
          }
          console.log('this.lockstate',this.lockstate);

          this.lockednft_2 = JSON.parse(JSON.stringify(this.lockednft));
          this.lockednft_3 = JSON.parse(JSON.stringify(this.lockednft));

          // -- ここまでethers
        } catch(e){
          console.log(e);  //metamaskで拒否など
        }


        // -----------------------------------
        // 保有しているNFTの情報取得
        const alchemy = new Alchemy(settings)
        
        this.array_tokenid.splice(0); //clear
        for(let i = 0; i < this.havenft.length; i++){
          // console.log('this.havenft' + i,this.havenft[i]);
          // console.log('this.havenft-change' + i,ethers.BigNumber.from(this.havenft[i]).toNumber());
          const response = await alchemy.nft.getNftMetadata( this.nft_contractAddress,ethers.BigNumber.from(this.havenft[i]).toNumber());
          this.array_tokenid.push({id:response.tokenId,title:response.title,image:response.rawMetadata.image})
        }

        // // NFTロック率取得
        // const response = await axios.get('https://app-webapi.azurewebsites.net/locktotal');
        // console.log("pandalock-response.data:",response);
        // var templock = response.data.split(',');
        // console.log("templock:",templock);

        // for(let i=0;i < 8;i++){
        //   this.nftLock[i] = Math.round((Number(templock[i]) / 7440) * 100 *100) /100;
        // }
        // console.log("pandalock:",this.nftLock);
        
        // var now = new Date(Date.now() + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000));
        // console.log("now:",now);
        // var chartday = new Array(8);
        // for(let i=0;i<8;i++){
        //   chartday[i] = new Date();
        //   chartday[i].setDate(now.getDate() - (i));
        // }
        
        // this.datacollection = {
        //   labels: [(chartday[7].getMonth() + 1) + "/" +  chartday[7].getDate(),
        //             (chartday[6].getMonth() + 1) + "/" +  chartday[6].getDate(),
        //             (chartday[5].getMonth() + 1) + "/" +  chartday[5].getDate(),
        //             (chartday[4].getMonth() + 1) + "/" +  chartday[4].getDate(),
        //             (chartday[3].getMonth() + 1) + "/" +  chartday[3].getDate(),
        //             (chartday[2].getMonth() + 1) + "/" +  chartday[2].getDate(),
        //             (chartday[1].getMonth() + 1) + "/" +  chartday[1].getDate(),
        //             (chartday[0].getMonth() + 1) + "/" +  chartday[0].getDate()],
        //   datasets: [
        //     {
        //       label: 'ロック率',
        //       backgroundColor: '#00FF69',
        //       data: [this.nftLock[7],this.nftLock[6],this.nftLock[5],this.nftLock[4],this.nftLock[3],
        //             this.nftLock[2],this.nftLock[1],this.nftLock[0]]
        //     }
        //   ]
        // }
        // // --------------------

        // // NFTポイント
        // const point_response = await axios.get('https://app-webapi.azurewebsites.net/stakeinfo?address=' + this.connect);
        // console.log("point_response.data:",point_response);
        // if(point_response.data != ""){ //新規ウォレットで購入した場合は取得できない
        //   var pointJson = point_response.data;
        //   console.log("pointJson:",pointJson);
        //   this.pandaPoint = Math.floor(Number(pointJson["total"]) / (60*60*24));
        //   console.log("pandaPoint:",this.pandaPoint);
        // }
        // // -------------------- 
      
        this.loading = false;  
        await this.changedisplay();
        await sleep( 1000 );  // 描画遅延対策
      }else{
        this.networkchange = true;
      }
    },

    // 個別ロック/解除を実行
    // async onClickSetting(index){
    //   this.loading = true;
    //   const set_tokenId = ethers.BigNumber.from(this.havenft[index]).toNumber();
    //   console.log('set_tokenId',set_tokenId);
    //   const set_val = this.lockednft[index];
    //   console.log('set_val',set_val);

    //   try{
    //     const provider = new ethers.providers.Web3Provider(this.ethereum)
    //     const abi = require("../contracts/abi_stake.json");
    //     const signer = provider.getSigner() ;
    //     const contract = new ethers.Contract(this.stake_contractAddress, abi, signer);

    //     // Lock設定変更を実行
    //     let tx;
    //     if(set_val == true){
    //       tx = await contract.setStartStake(set_tokenId);
    //     }else{
    //       // TimeStamp生成
    //       var date = new Date();
    //       console.log('date',date);
    //       var effectiveDate = Math.floor(date.setHours(date.getUTCDate() + 24) / 1000 );
    //       console.log('effectiveDate',effectiveDate);
    //       const coupon = await this.OffchainSig(set_tokenId,effectiveDate);
    //       console.log('coupon',coupon);
    //       tx = await contract.setEndStake(set_tokenId,effectiveDate,coupon);
    //     }
        
    //     const result = await tx.wait();
    //     console.log('seted',result.gasUsed.toNumber());

    //     //! 切り替え
    //     await axios.get('https://api.opensea.io/api/v1/asset/' + this.nft_contractAddress + '/' + String(set_tokenId)+ '/?force_update=true')
    //     //await axios.get('https://testnets-api.opensea.io/api/v1/asset/' + this.nft_contractAddress + '/' + String(set_tokenId) + '/?force_update=true')
    //           .then(function (response) {
    //             console.log(response.data);
    //           })
    //   }catch(e){
    //     console.log(e);  //metamaskで拒否など
    //   }

    //   await this.onClickConnect();
    //   this.loading = false;
    // },

    // 一括ロックを実行
    async onClickSetting_2(){
      this.loading = true;
      var lockarray= new Array();
      var set_tokenId;
      for(var i =0; i <this.lockednft_2.length;i++){
        if(this.lockednft_2[i] == true && this.const_lockednft[i] == false){
          set_tokenId = ethers.BigNumber.from(this.havenft[i]).toNumber();
          lockarray.push(set_tokenId);
          console.log('set_tokenId',set_tokenId);
        }
      }

      try{
        const provider = new ethers.providers.Web3Provider(this.ethereum)
        const abi = require("../contracts/abi_stake.json");
        const signer = provider.getSigner() ;
        const contract = new ethers.Contract(this.stake_contractAddress, abi, signer);

        // Lock設定変更を実行
        let tx = await contract.setStartStakeArray(lockarray);      
        const result = await tx.wait();
        console.log('array_seted',result.gasUsed.toNumber());

        for(var j = 0;j < lockarray.length;j++){
          //! 切り替え
          await axios.get('https://api.opensea.io/api/v1/asset/' + this.nft_contractAddress + '/' + String(lockarray[j]) + '/?force_update=true')
          // await axios.get('https://testnets-api.opensea.io/api/v1/asset/' + this.nft_contractAddress + '/' + String(lockarray[j]) + '/?force_update=true')
              .then(function (response) {
                console.log(response.data);
              })
          await sleep( 1000 );
        }
      }catch(e){
        console.log(e);  //metamaskで拒否など
      }

      await this.onClickConnect();
      this.loading = false;
    },

    // 一括解除を実行
    async onClickSetting_3(){
      this.loading = true;
      var lockarray= new Array();
      var set_tokenId;
      for(var i =0; i <this.lockednft_3.length;i++){
        if(this.lockednft_3[i] == false && this.const_lockednft[i] == true){
          set_tokenId = ethers.BigNumber.from(this.havenft[i]).toNumber();
          lockarray.push(set_tokenId);
          console.log('set_tokenId',set_tokenId);
        }
      }

      try{
        const provider = new ethers.providers.Web3Provider(this.ethereum)
        const abi = require("../contracts/abi_stake.json");
        const signer = provider.getSigner() ;
        const contract = new ethers.Contract(this.stake_contractAddress, abi, signer);

        // Lock設定変更を実行
        // TimeStamp生成
        var date = new Date();
        console.log('date',date);
        var effectiveDate = Math.floor(date.setHours(date.getUTCDate() + 24) / 1000 );
        console.log('effectiveDate',effectiveDate);

        var effectiveDateList = new Array();
        var couponList = new Array();
        for(var n=0; n < lockarray.length;n++){
          effectiveDateList[n] = effectiveDate;
          console.log('effectiveDateList',effectiveDateList);
          //const coupon = await this.OffchainSig(lockarray[n],effectiveDate);
          const coupon = await axios.post(SIG_API_URL,{
                                                  tokenid:lockarray[n],
                                                  time:effectiveDate,
                                                  address:this.connect.toString()
                                                },
                                                {
                                                  'Content-Type': 'application/json',
                                                  'Access-Control-Allow-Origin': '*'
                                                });
          console.log('coupon',coupon);
          couponList[n] = coupon.data;
          console.log('couponList',couponList);
        }

        console.log('lockarray',lockarray);
        console.log('effectiveDateList',effectiveDateList);
        console.log('couponList',couponList);

        var tx = await contract.setEndStakeArray(lockarray,effectiveDateList,couponList);    
        const result = await tx.wait();
        console.log('array_seted',result.gasUsed.toNumber());

        for(var j = 0;j < lockarray.length;j++){
          //! 切り替え
          await axios.get('https://api.opensea.io/api/v1/asset/' + this.nft_contractAddress + '/' + String(lockarray[j]) + '/?force_update=true')
          // await axios.get('https://testnets-api.opensea.io/api/v1/asset/' + this.nft_contractAddress + '/' + String(lockarray[j]) + '/?force_update=true')
              .then(function (response) {
                console.log(response.data);
              })
          await sleep( 1000 );
        }
      }catch(e){
        console.log(e);  //metamaskで拒否など
      }

      await this.onClickConnect();
      this.loading = false;
    },

    // 個別管理
    // async onModeCahange(){  //モード切替
    //   console.log('onModeCahange');
    //   this.toggled = 1;
    //   this.$nextTick(function() {
    //     this.changedisplay();
    //   })
    // },
    // async onCheckCahange(){ // チェック変更
    //   console.log('onCheckCahange');
    //   await this.changedisplay();
    // },
    // async changedisplay(){
    //   for(let i =0; i < this.const_lockednft.length;i++){
    //     if(this.const_lockednft[i] != this.lockednft[i]){
    //       this.lockedchange[i] = true;
    //       // console.log('change-check:true' + i,this.lockedchange[i]);
    //     }else{
    //       this.lockedchange[i] = false;
    //       // console.log('change-check:false' + i,this.lockedchange[i]);
    //     }

    //     var elem = document.querySelector('#image' + String(i));
    //     if(this.lockednft[i] == true){
    //       this.lockedchange_string[i] = "lock";
    //       elem.style.border = "5px dotted #FF0000";
    //     }else{
    //       this.lockedchange_string[i] = "unlock";
    //       elem.style.border = "none";
    //     }
    //   }
    // },
    // 一括ロック
    async onModeCahange_2(){  //モード切替
      console.log('onModeCahange_2');
      this.toggled = 2;
      // 初期化
      this.lockednft_2 = JSON.parse(JSON.stringify(this.lockednft));

      this.$nextTick(function() {
        this.changedisplay_2();
      })
    },
    async onCheckCahange_2(){ // チェック変更
      console.log('onCheckCahange_2');
      await this.changedisplay_2();
    },
    async changedisplay_2(){
      var enable = false;
      for(let i =0; i < this.const_lockednft.length;i++){
        if(this.const_lockednft[i] == false){
          if(this.const_lockednft[i] != this.lockednft_2[i]){
            this.lockedchange_2[i] = true;
            enable = true;
            // console.log('change-check:true' + i,this.lockedchange[i]);
          }else{
            this.lockedchange_2[i] = false;
            // console.log('change-check:false' + i,this.lockedchange[i]);
          }

          var elem = document.querySelector('#image' + String(i));
          if(this.lockednft_2[i] == true){
            this.lockedchange_string_2[i] = "lock";
            //elem.style.border = "5px dotted #FF0000";
            elem.style = "border:8px dotted;border-image:linear-gradient(to right bottom,red, orange, yellow, green, blue, indigo, violet) 1 / 1 / 0 ";
            // elem.style = "border-image:linear-gradient(to right bottom,red, orange, yellow, green, blue, indigo, violet) 1 / 1 / 0";
          }else{
            this.lockedchange_string_2[i] = "unlock";
            elem.style.border = "none";
          }
        }
      }

      if(enable == true){
        this.enableGo_2 = true;
      }else{
        this.enableGo_2 = false;
      }
    },

    // 一括解除
    async onModeCahange_3(){  //モード切替
      console.log('onModeCahange_3');
      this.toggled = 3;
      // 初期化
      this.lockednft_3 = JSON.parse(JSON.stringify(this.lockednft));

      this.$nextTick(function() {
        this.changedisplay_3();
      })
    },
    async onCheckCahange_3(){  // チェック変更
      console.log('onCheckCahange_3');
      await this.changedisplay_3();
    },
    async changedisplay_3(){
      var enable = false;
      for(let i =0; i < this.const_lockednft.length;i++){
        if(this.const_lockednft[i] == true){
          if(this.const_lockednft[i] != this.lockednft_3[i]){
            this.lockedchange_3[i] = true;
            enable = true;
            // console.log('change-check:true' + i,this.lockedchange[i]);
          }else{
            this.lockedchange_3[i] = false;
            // console.log('change-check:false' + i,this.lockedchange[i]);
          }

          var elem = document.querySelector('#image' + String(i));
          if(this.lockednft_3[i] == true){
            this.lockedchange_string_3[i] = "lock";
            //elem.style.border = "5px dotted #FF0000";
            elem.style = "border:8px dotted;border-image:linear-gradient(to right bottom,red, orange, yellow, green, blue, indigo, violet) 1 / 1 / 0 ";
          }else{
            this.lockedchange_string_3[i] = "unlock";
            elem.style.border = "none";
          }
        }
      }

      if(enable == true){
        this.enableGo_3 = true;
      }else{
        this.enableGo_3 = false;
      }
    },
    // ロック情報
    async onModeCahange_4(){  //モード切替
      console.log('onModeCahange_4');
      this.toggled = 4;
      
      
    },

    // ブラウザでメタマスクが使える状態かどうかを返す
    canUseMetaMask () {
      // console.log(this.ethereum)
      return this.ethereum !== undefined;
    },
    // メタマスクに接続されているかどうかを返す
    connectedMetaMask () {
      //console.log(this.connect)
      return this.canUseMetaMask() && this.connect != null;
    },
    // connectedTargetNetwork () {
    //   console.log(this.ethereum.chainId )
    //   return this.connectedMetaMask() && window.ethereum.chainId === '0x4';
    // },
    // connectedMaticNetwork () {
    //   return this.connectedMetaMask() && window.ethereum.chainId === '0x89';
    // },

  },
}
</script>
<!-- ///////////////////////////////////////////////////////////////////////////////////////// -->
<!-- // CSS -->
<!-- ///////////////////////////////////////////////////////////////////////////////////////// -->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{
  text-align: center;
  width:70%;
  padding:20px;
}
.locklogo{
    width:15%;
    height:15%;
}

@media screen and (max-width: 800px) {
  .container{
    width:100%;
    font-size: 16px;
  }
  .locklogo{
    width:50%;
    height:50%;
  }
}

/* ボタン横幅カスタム */
.w-180px {
  width: 180px !important;
}

.StatsInfoStyle{
  text-align: left;
  display: inline-block;  /* テキスト左寄せのまま中央表示できる */
  margin:20px;
  padding:1.5em;
  border-radius:20px;
  background-color: whitesmoke;
}

.collection-title{
  /* height: 100px; */
  font-weight: bold;
  font-size: x-large;
  margin:10px;

  /* display: flex;
  justify-content: center;
  flex-wrap: wrap; */
}
.collection-detail{
  font-weight:normal;
  font-size: small;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  /* margin: 0px,20px,0px,20px; */
}
.imagecollection {
    /* border: outset 10px #900; */
    border: 8px solid black;
    border-radius:20px;
}
.imagebox{
  margin:10px;
}
.box {
    inline-size: 120px;
    overflow-wrap: break-word;
    height: 50px;
}

	hr {
    border-width: 0 0 8px;
    border-style: solid;
    border-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2 1"><circle fill="hsla(0, 0%, 65%, 1.0)" cx="1" cy="0.5" r="0.5"/></svg>') 0 0 100% repeat;
    width: 100%;
	}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

/* Loding stye */
.loader {
  margin: 100px auto;
  font-size: 25px;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  -webkit-animation: load5 1.1s infinite ease;
  animation: load5 1.1s infinite ease;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
@-webkit-keyframes load5 {
  0%,
  100% {
    box-shadow: 0em -2.6em 0em 0em #000000, 1.8em -1.8em 0 0em rgba(0,0,0, 0.2), 2.5em 0em 0 0em rgba(0,0,0, 0.2), 1.75em 1.75em 0 0em rgba(0,0,0, 0.2), 0em 2.5em 0 0em rgba(0,0,0, 0.2), -1.8em 1.8em 0 0em rgba(0,0,0, 0.2), -2.6em 0em 0 0em rgba(0,0,0, 0.5), -1.8em -1.8em 0 0em rgba(0,0,0, 0.7);
  }
  12.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.7), 1.8em -1.8em 0 0em #000000, 2.5em 0em 0 0em rgba(0,0,0, 0.2), 1.75em 1.75em 0 0em rgba(0,0,0, 0.2), 0em 2.5em 0 0em rgba(0,0,0, 0.2), -1.8em 1.8em 0 0em rgba(0,0,0, 0.2), -2.6em 0em 0 0em rgba(0,0,0, 0.2), -1.8em -1.8em 0 0em rgba(0,0,0, 0.5);
  }
  25% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.5), 1.8em -1.8em 0 0em rgba(0,0,0, 0.7), 2.5em 0em 0 0em #000000, 1.75em 1.75em 0 0em rgba(0,0,0, 0.2), 0em 2.5em 0 0em rgba(0,0,0, 0.2), -1.8em 1.8em 0 0em rgba(0,0,0, 0.2), -2.6em 0em 0 0em rgba(0,0,0, 0.2), -1.8em -1.8em 0 0em rgba(0,0,0, 0.2);
  }
  37.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.2), 1.8em -1.8em 0 0em rgba(0,0,0, 0.5), 2.5em 0em 0 0em rgba(0,0,0, 0.7), 1.75em 1.75em 0 0em #000000, 0em 2.5em 0 0em rgba(0,0,0, 0.2), -1.8em 1.8em 0 0em rgba(0,0,0, 0.2), -2.6em 0em 0 0em rgba(0,0,0, 0.2), -1.8em -1.8em 0 0em rgba(0,0,0, 0.2);
  }
  50% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.2), 1.8em -1.8em 0 0em rgba(0,0,0, 0.2), 2.5em 0em 0 0em rgba(0,0,0, 0.5), 1.75em 1.75em 0 0em rgba(0,0,0, 0.7), 0em 2.5em 0 0em #000000, -1.8em 1.8em 0 0em rgba(0,0,0, 0.2), -2.6em 0em 0 0em rgba(0,0,0, 0.2), -1.8em -1.8em 0 0em rgba(0,0,0, 0.2);
  }
  62.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.2), 1.8em -1.8em 0 0em rgba(0,0,0, 0.2), 2.5em 0em 0 0em rgba(0,0,0, 0.2), 1.75em 1.75em 0 0em rgba(0,0,0, 0.5), 0em 2.5em 0 0em rgba(0,0,0, 0.7), -1.8em 1.8em 0 0em #000000, -2.6em 0em 0 0em rgba(0,0,0, 0.2), -1.8em -1.8em 0 0em rgba(0,0,0, 0.2);
  }
  75% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.2), 1.8em -1.8em 0 0em rgba(0,0,0, 0.2), 2.5em 0em 0 0em rgba(0,0,0, 0.2), 1.75em 1.75em 0 0em rgba(0,0,0, 0.2), 0em 2.5em 0 0em rgba(0,0,0, 0.5), -1.8em 1.8em 0 0em rgba(0,0,0, 0.7), -2.6em 0em 0 0em #000000, -1.8em -1.8em 0 0em rgba(0,0,0, 0.2);
  }
  87.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.2), 1.8em -1.8em 0 0em rgba(0,0,0, 0.2), 2.5em 0em 0 0em rgba(0,0,0, 0.2), 1.75em 1.75em 0 0em rgba(0,0,0, 0.2), 0em 2.5em 0 0em rgba(0,0,0, 0.2), -1.8em 1.8em 0 0em rgba(0,0,0, 0.5), -2.6em 0em 0 0em rgba(0,0,0, 0.7), -1.8em -1.8em 0 0em #000000;
  }
}
@keyframes load5 {
  0%,
  100% {
    box-shadow: 0em -2.6em 0em 0em #000000, 1.8em -1.8em 0 0em rgba(0,0,0, 0.2), 2.5em 0em 0 0em rgba(0,0,0, 0.2), 1.75em 1.75em 0 0em rgba(0,0,0, 0.2), 0em 2.5em 0 0em rgba(0,0,0, 0.2), -1.8em 1.8em 0 0em rgba(0,0,0, 0.2), -2.6em 0em 0 0em rgba(0,0,0, 0.5), -1.8em -1.8em 0 0em rgba(0,0,0, 0.7);
  }
  12.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.7), 1.8em -1.8em 0 0em #000000, 2.5em 0em 0 0em rgba(0,0,0, 0.2), 1.75em 1.75em 0 0em rgba(0,0,0, 0.2), 0em 2.5em 0 0em rgba(0,0,0, 0.2), -1.8em 1.8em 0 0em rgba(0,0,0, 0.2), -2.6em 0em 0 0em rgba(0,0,0, 0.2), -1.8em -1.8em 0 0em rgba(0,0,0, 0.5);
  }
  25% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.5), 1.8em -1.8em 0 0em rgba(0,0,0, 0.7), 2.5em 0em 0 0em #000000, 1.75em 1.75em 0 0em rgba(0,0,0, 0.2), 0em 2.5em 0 0em rgba(0,0,0, 0.2), -1.8em 1.8em 0 0em rgba(0,0,0, 0.2), -2.6em 0em 0 0em rgba(0,0,0, 0.2), -1.8em -1.8em 0 0em rgba(0,0,0, 0.2);
  }
  37.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.2), 1.8em -1.8em 0 0em rgba(0,0,0, 0.5), 2.5em 0em 0 0em rgba(0,0,0, 0.7), 1.75em 1.75em 0 0em #000000, 0em 2.5em 0 0em rgba(0,0,0, 0.2), -1.8em 1.8em 0 0em rgba(0,0,0, 0.2), -2.6em 0em 0 0em rgba(0,0,0, 0.2), -1.8em -1.8em 0 0em rgba(0,0,0, 0.2);
  }
  50% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.2), 1.8em -1.8em 0 0em rgba(0,0,0, 0.2), 2.5em 0em 0 0em rgba(0,0,0, 0.5), 1.75em 1.75em 0 0em rgba(0,0,0, 0.7), 0em 2.5em 0 0em #000000, -1.8em 1.8em 0 0em rgba(0,0,0, 0.2), -2.6em 0em 0 0em rgba(0,0,0, 0.2), -1.8em -1.8em 0 0em rgba(0,0,0, 0.2);
  }
  62.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.2), 1.8em -1.8em 0 0em rgba(0,0,0, 0.2), 2.5em 0em 0 0em rgba(0,0,0, 0.2), 1.75em 1.75em 0 0em rgba(0,0,0, 0.5), 0em 2.5em 0 0em rgba(0,0,0, 0.7), -1.8em 1.8em 0 0em #000000, -2.6em 0em 0 0em rgba(0,0,0, 0.2), -1.8em -1.8em 0 0em rgba(0,0,0, 0.2);
  }
  75% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.2), 1.8em -1.8em 0 0em rgba(0,0,0, 0.2), 2.5em 0em 0 0em rgba(0,0,0, 0.2), 1.75em 1.75em 0 0em rgba(0,0,0, 0.2), 0em 2.5em 0 0em rgba(0,0,0, 0.5), -1.8em 1.8em 0 0em rgba(0,0,0, 0.7), -2.6em 0em 0 0em #000000, -1.8em -1.8em 0 0em rgba(0,0,0, 0.2);
  }
  87.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(0,0,0, 0.2), 1.8em -1.8em 0 0em rgba(0,0,0, 0.2), 2.5em 0em 0 0em rgba(0,0,0, 0.2), 1.75em 1.75em 0 0em rgba(0,0,0, 0.2), 0em 2.5em 0 0em rgba(0,0,0, 0.2), -1.8em 1.8em 0 0em rgba(0,0,0, 0.5), -2.6em 0em 0 0em rgba(0,0,0, 0.7), -1.8em -1.8em 0 0em #000000;
  }
}


/* Loding stye */

input[type=checkbox] {
  -ms-transform: scale(2.0, 2.0);
  -webkit-transform: scale(2.0, 2.0);
  transform: scale(2.0, 2.0);
}
/* input[type=checkbox] {
  -ms-transform: scale(1.5, 1.5);
  -webkit-transform: scale(1.5, 1.5);
  transform: scale(1.5, 1.5);
} */

hr {
  border-width: 0 0 8px;
  border-style: solid;
  border-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2 1"><circle fill="hsla(0, 0%, 65%, 1.0)" cx="1" cy="0.5" r="0.5"/></svg>') 0 0 100% repeat;
  width: 100%;
}



</style>
